<template>
  <v-dialog v-model="dialog" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <template v-slot:activator="{ on }">
      <div id="login-button">
        <v-btn :class="[!$vuetify.breakpoint.xsOnly ? 'loginDesktop' : '']" color="primary" tile :icon="$vuetify.breakpoint.xsOnly" dark v-on="on">
          <v-icon>mdi-login-variant</v-icon>
          <span v-if="!$vuetify.breakpoint.xsOnly">Anmelden</span>
        </v-btn>
      </div>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">Geben Sie Ihre Anmeldedaten ein</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" @change="validate">
            <v-row align="center">
              <v-col cols="12">
                <v-text-field v-model="user" id="user" :rules="userRules" label="Nutzername *"
                  @keyup.enter="() => loginUser(null, null)" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="password" id="password" :rules="pwRules" :append-icon="showpw ? 'visibility' : 'visibility_off'"
                  label="Passwort *" :type="showpw ? 'text' : 'password'" @click:append="showpw = !showpw"
                  @keyup.enter="() => loginUser(null, null)" counter required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-alert v-if="(!valid && hasError) || hasError" type="error">
                  Bitte überprüfen Sie Ihren Nutzernamen und Ihr Passwort.
                </v-alert>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <small>* Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" text @click="dialog = false" :disabled="loading">Abbrechen</v-btn>
        <v-btn color="blue darken-1" text @click="() => loginUser(null, null)" :disabled="!valid || loading" :loading="loading">Anmelden</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* tslint:disable:no-console */
import { mapState } from 'vuex';
export default {
  data: () => ({
    valid: false,
    dialog: false,
    showpw: false,
    loading: false,
    hasError: false,
    user: '',
    email: '',
    password: '',
    userRules: [
      (v) => !!v || 'Username ist ein Pflichtfeld',
      (v) => /^([\w\-\.]{4,29})$/.test(v) || 'Username ist ungültig',
    ],
    emailRules: [
      (v) => !!v || 'E-mail ist ein Pflichtfeld',
      (v) => /.+@.+\..+/.test(v) || 'E-mail ist ungültig',
    ],
    pwRules: [
      (v) => !!v || 'Passwort ist ein Pflichtfeld',
      (v) => (v && v.length >= 3) || 'Passwort muss mindestens 3 Zeichen enthalten',
    ],
  }),
  computed: {
    ...mapState({
      userAuthenticated: (state) => state.app.userAuthenticated,
      username: (state) => state.app.username,
    }),
  },
  mounted() {
    setTimeout(() => {
      this.$store.restored.then(() => {
        const payload = this.$store.state.app.userTokenPayload;
        const rightNow = Math.floor(new Date().getTime() / 1000);
        const restLife = payload.exp - rightNow;

        const query = this.$router.history.current.query;
        if (query && query.a && !this.userAuthenticated) {
          const text = query.a;
          const a = text.split(':').shift();
          const b = text.replace(a, '').substring(1);
          this.dialog = true;
          this.user = a;
          this.password = b;
          console.log('AUTOLOGIN');
          return this.loginUser(a, b, true);
        }

        // token expired or no payload
        if (isNaN(restLife) || restLife <= 0) {
          this.$store.commit('setUserAuthenticated', false);

          return this.loginAsGuest();
        }

        if (this.userAuthenticated || this.username === 'gast') {
          if (location.pathname === '/') {
            this.$router.push('/home');
          }
        } else {
          this.loginAsGuest();
        }
      });
    }, 500);
  },
  methods: {
    validate() {
      this.valid = this.$refs.form.validate();
    },
    loginAsGuest() {
      if (!this.loading) {
        this.loginUser('gast', 'gast');
      }
    },
    async loginUser(username, password, autoLogin) {
      if (this.valid || (username && password)) {
        this.loading = true;
        try {
          const URL = process.env.VUE_APP_AUTH_URL;
          const response = await fetch(URL + '/auth/login', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              username: username || this.user,
              password: password || this.password,
            }),
          });
          const token = await response.text();
          if (response.status >= 400) {
            this.hasError = true;
          } else {
            if (token) {
              this.dialog = false;
              this.$store.commit('setJWT', token);
              if (username !== 'gast') {
                this.$store.commit('setUserAuthenticated', true);
              }
              if (this.$route.name !== 'home' && !autoLogin) {
                this.$router.push('/home');
              } else {
                this.$router.push({ path: this.$router.history.current.path });
                // the search functionality doesn't trigger, so a reload is necessary
                setTimeout(() => {
                  return this.$router.go();
                }, 100);
              }
              this.$store.dispatch('fetchList', 'loginView');
            }
          }
        } catch (error) {
          console.log('There has been a problem with your fetch operation: ', error.message);
          this.dialog = false;
          this.$store.commit('setUserAuthenticated', false);
          this.hasError = true;
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less">
  .v-content #login-button {
    display: none;
  }
  .loginDesktop {
    right: 20px;
  }
</style>
